import { Check } from '@mui/icons-material';
import { Box, Button, CircularProgress, Container } from '@mui/material';
import { Subheader } from 'components';
import InPersonEventForm from './InPersonEventForm';
import {
	useAlerts,
	useInPersonEvents,
	useTimezones,
	useUploadFileInMemory
} from 'hooks';
import { validateInPersonEvent } from 'validations/events';
import { isArray } from 'lodash';
import { useNavigate } from 'react-router-dom';

export default function InPersonEventNew() {
	const { handleChange, inPersonEvent, createInPersonEvent, isLoading } =
		useInPersonEvents();

	const { memoryFile, removeFile, handleUploadFile } = useUploadFileInMemory();
	const { showAlertError, showAlertSuccess } = useAlerts();
	const navigate = useNavigate();

	const handleSaveClick = async () => {
		const valid = validateInPersonEvent(inPersonEvent);

		if (!valid.isValid) {
			showAlertError(valid.messages[0]);
			return;
		}

		if (!memoryFile) {
			showAlertError('Event Image is required');
			return;
		}

		const response = await createInPersonEvent(
			{ ...inPersonEvent, event_type: 'in_person' },
			memoryFile
		);
		if (response.status && response.status !== 201) {
			const error = response?.data?.error;
			const defaultMessage = 'Fail to create, try again';

			if (isArray(error)) {
				showAlertError(response?.data?.error[0] || defaultMessage);
			} else {
				showAlertError(response?.data?.error || defaultMessage);
			}

			return;
		}
		showAlertSuccess('In-Person Event created');

		navigate(-1);
	};

	const handleUpload = async (file, type) => {
		await handleUploadFile(file, type);
	};

	const handleDelete = async () => {
		await removeFile();
	};

	return (
		<div>
			<Subheader
				title="Add In-Person Events"
				buttons={[
					<Button
						color="primary"
						variant="contained"
						startIcon={isLoading ? <CircularProgress size={18} /> : <Check />}
						onClick={handleSaveClick}
						disabled={isLoading}
					>
						Save
					</Button>
				]}
			/>

			<Container>
				<Box p={4}>
					<InPersonEventForm
						inPersonEvent={inPersonEvent}
						handleChange={handleChange}
						memoryFile={memoryFile}
						handleDelete={handleDelete}
						handleUpload={handleUpload}
					/>
				</Box>
			</Container>
		</div>
	);
}
